module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "people hidden-sm hidden-xs",
    style: ({
      background: 'url(' + _vm.featuredImage + ') center no-repeat',
      backgroundSize: 'cover'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "main_content"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo,
      "alt": "community management logo"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "main_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "title_bottom_text"
  }, [_vm._v(_vm._s(_vm.subTitle))]), _vm._v(" "), _c('div', {
    staticClass: "login_area"
  }, [_c('h3', [_vm._v("\n                            Welcome To " + _vm._s(_vm.title) + ". Please Login To Access.\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success login_btn",
    on: {
      "click": function($event) {
        _vm.makeLogin('sensa')
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom_text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.footerText)
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490e830e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Login.vue
// module id = 445
// module chunks = 57